import { makeStyles } from '@material-ui/core';

export const produtoServicoListStyles = makeStyles({
  container: {
    marginBottom: '0 !important',
  },
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
  },
  buttonAdicionarProdutoServico: {
    color: '#53c4e6',
    fontSize: 15,
    marginTop: 8,
  },
});

export const produtoServicoItemStyles = makeStyles({
  produtoServicoNomeContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  containerInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonRemoveContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
});
